import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { AUTH_PATHS, userManager } from './auth';
import '@fontsource-variable/ibm-plex-sans';
// Ten sam wygląd co aplikacja klienta — z tego samego źródła (packages/design)
import '@firmeto/design/tokens.css';
import '@firmeto/design/app.css';
import '@firmeto/design/app-shell.css';
import '@firmeto/design/entry.css';

// Ciche odnowienie tokenu odbywa się w ukrytej ramce, która ładuje tę samą stronę.
// Wtedy nie budujemy interfejsu — ramka ma tylko oddać wynik oknu głównemu.
if (window.location.pathname === AUTH_PATHS.silentRenew) {
  void userManager.signinSilentCallback();
} else {
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}
